// removed by extract-text-webpack-plugin
module.exports = {"publicsection":"wmf-wWpanJ9I","publlictitle":"wmf-1pyHtAJK","required":"wmf-2mJyvuFn","informationtitle":"wmf-24TyI_3z","titles":"wmf-97B2bfEv","skustyle":"wmf-2Le-h5w5"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/commoditymanagement/addcompleteinformation/medicalequipmentnhaitao/medical-equipmentn-haitao.module.less
// module id = 614
// module chunks = 0